import { Card, List, ListItem, ListItemText } from "@material-ui/core";
import locale from "@bonliva-crm/locale";

type Props = {
  onCreateCallList: (event: React.MouseEvent<HTMLElement>) => void;
  onCreateContactList: (event: React.MouseEvent<HTMLElement>) => void;
};

export function CreateListMenu(props: Props) {
  return (
    <Card style={{ padding: 0, marginLeft: 8, marginRight: 8 }}>
      <List>
        <ListItem button onClick={props.onCreateCallList}>
          <ListItemText primary={locale.NewCallList} />
        </ListItem>

        <ListItem button onClick={props.onCreateContactList}>
          <ListItemText primary={locale.NewContactList} />
        </ListItem>
      </List>
    </Card>
  );
}
